import { useEffectOnce } from 'react-use';
import { googleAnalyticsClient } from '../../../clients';

/**
 *
 */
const useInitAnalytics = () => {
  useEffectOnce(() => {
    googleAnalyticsClient.init();
  });
};

export default useInitAnalytics;
